<template>
    <section>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <required /> <label :class="{'text-red': errors.has('Nome') }">Nome do Grupo</label>
                    <div class="input-group">
                        <input name="Nome" :class="{'is-invalid': errors.has('Nome') }" v-validate="{required: true}"
                            placeholder="Digite o nome" v-model="request.nome" class="form-control">
                        <span class="input-group-btn">
                            <button :disabled="loading" type="button" @click="save()"
                                class="btn btn-outline-secondary btn-flat">
                                <i class="fa fa-save"></i>
                                Salvar
                            </button>
                        </span>
                        <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <dual-list ref="dualList" :title="dualListSettings.title" :storeAction="dualListSettings.storeAction"
                :selectedData="request.signatarios"></dual-list>
        </div>
    </section>
</template>
<script>
    import DualList from '../../components/DualList.vue'
    export default {
        components: {
            DualList
        },
        data() {
            return {
                loading: false,
                dualListSettings: {
                    title: 'Signatários',
                    storeAction: 'getAllSignatariosSelect'
                },
                request: {
                    id: null,
                    nome: null,
                    signatarios: []
                }
            }
        },
        methods: {
            syncList() {
                this.request = {
                    id: null,
                    nome: null,
                    signatarios: []
                }
                this.$refs.dualList.fetchData();

            },
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        return;
                    }
                    if (!this.request.signatarios.length) {
                        toastr({
                            icon: 'error',
                            title: 'Adicione os signatários!'
                        });
                        return;
                    }
                    this.loading = true;
                    this.$store.dispatch('saveGrupoSignatario', this.request).then(response => {
                        toastr({
                            icon: response.status,
                            title: response.message
                        });
                        this.$emit('saveData');
                        this.syncList();
                    }).catch(error => {
                        console.log(error);
                        toastr({
                            icon: error.status,
                            title: error.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    })
                });
            },
        }

    }
</script>